// extracted by mini-css-extract-plugin
module.exports = {"item":"NumberedItems_item__CSYeh","number":"NumberedItems_number__9LlMn"};